// import {  useState } from 'react';

import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    InputLabel,
    Stack,
    TextField
} from '@mui/material';

import _ from 'lodash';
import * as Yup from 'yup';
import {useFormik, Form, FormikProvider, FormikValues} from 'formik';
import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

import * as yup from "yup";
import {addItem, editItem} from "store/reducers/hr/award";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import EmployeeAutoComplete from "../../employees/extras/employee-autocomplete";
import {useState} from "react";
import {format} from "date-fns";

// constant
const getInitialValues = (award: FormikValues | null) => {


    const newAward = {
        award_name: '',
        employee_id:'',
        gift:'',
        cash_price:'',
        for_month:new Date(),
        for_year:new Date(),
    };

    if (award) {
        return _.merge({}, newAward, award);
    }


    return newAward;
};

// ==============================|| CUSTOMER - ADD / EDIT ||============================== //

export interface Props {
    award?: any;
    onCancel: () => void;
}

const AddAward = ({ award, onCancel }: Props) => {


    const AwardSchema = Yup.object().shape({
        award_name: yup.string().max(255).required('Name is required'),
        employee_id: yup.number().required('Employee is required'),
        gift: yup.string().max(255).required('Gift is required'),
        // cash_price: yup.string().max(255).required('Price is required'),
        for_month: yup.string().max(255).required('Month is required'),
        for_year: yup.string().max(255).required('Year is required'),

    });

    const [editEmployee,setEditEmployee]=useState<any|null>(award? award.employee : null);


    const formik = useFormik({
        enableReinitialize:award? true:false,
        initialValues: getInitialValues(award!),
        validationSchema: AwardSchema,
        onSubmit: (values, { setSubmitting }) => {



            try {
                const newAward = {
                    award_name: values.award_name,
                    employee_id:values.employee_id,
                    gift:values.gift,
                    cash_price:values.cash_price,
                    for_month:format(values.for_month,'MMMM'),
                    for_year:format(values.for_year,'yyyy'),
                };
                console.log(newAward);

                if (award) {
                    dispatch(editItem(award.id, newAward));
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Award update successfully.',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: false
                        })
                    );
                } else {
                    dispatch(addItem(newAward)).then((response)=>{
                        console.log(response);

                        dispatch(
                            openSnackbar({
                                open: true,
                                message: 'Award added successfully.',
                                variant: 'alert',
                                alert: {
                                    color: 'success'
                                },
                                close: false
                            })
                        );
                    });

                }

                setSubmitting(false);
                onCancel();
            } catch (error) {
                console.error(error);
            }
        }
    });
    const handleOnEmployeeToSelect=(event:any,value: any)=>{
        setEditEmployee(value)
        formik.setFieldValue('employee_id',value.id)
    }
    const { errors, touched, handleSubmit, isSubmitting, getFieldProps,setFieldValue ,values} = formik;

    return (
        <>

            <FormikProvider value={formik}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Form   onSubmit={handleSubmit}>
                    <DialogTitle>{award ? 'Update Award' : 'New Award'}</DialogTitle>
                    <Divider />
                    <DialogContent sx={{ p: 2.5 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}  md={12}>
                                <Grid container spacing={3}>

                                    <Grid item xs={12}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="followUp-last-name">Employee</InputLabel>
                                            <EmployeeAutoComplete getFieldProps={getFieldProps('employee_id')} onSelect={handleOnEmployeeToSelect} selected={editEmployee?? (award?.employee)} ></EmployeeAutoComplete>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="award-name">Award  Name</InputLabel>
                                            <TextField
                                                fullWidth
                                                id="award-first-name"
                                                placeholder="Enter Award Name"

                                                {...getFieldProps('award_name')}
                                                error={Boolean(touched.award_name && errors.award_name)}
                                                helperText={touched.award_name && errors.award_name}
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="award-name">Gift</InputLabel>
                                            <TextField
                                                fullWidth
                                                id="award-first-name"
                                                placeholder="Enter Gift"

                                                {...getFieldProps('gift')}
                                                error={Boolean(touched.gift && errors.gift)}
                                                helperText={touched.gift && errors.gift}
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="award-cash-price">Cash Price</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                id="award-cash-price"
                                                placeholder="Enter Cash Price"

                                                {...getFieldProps('cash_price')}
                                                error={Boolean(touched.cash_price && errors.cash_price)}
                                                helperText={touched.cash_price && errors.cash_price}
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="cal-start-date">For Month</InputLabel>
                                            <DatePicker
                                                // disableFuture
                                                // label="For Month"
                                                openTo="month"
                                                views={[ 'month']}
                                                value={new Date('01/' + values.for_month)}
                                                onChange={(newValue:any) => {
                                                    setFieldValue('for_month',newValue);
                                                }}
                                                // renderInput={(params:any) => <TextField {...params} />}
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={1.25}>
                                            <InputLabel htmlFor="cal-start-date">For Year</InputLabel>
                                            <DatePicker
                                                // disableFuture
                                                // label="For Month"
                                                openTo="year"
                                                views={[ 'year']}
                                                value={new Date(values.for_year)}
                                                onChange={(newValue:any) => {
                                                    setFieldValue('for_year',newValue);
                                                }}
                                                // renderInput={(params:any) => <TextField {...params} />}
                                            />
                                        </Stack>
                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>

                    </DialogContent>
                    <Divider />
                    <DialogActions sx={{ p: 2.5 }}>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>

                            </Grid>
                            <Grid item>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Button color="error" onClick={onCancel}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="contained" disabled={isSubmitting}>
                                        {award ? 'Update' : 'Add'}
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Form>
                </LocalizationProvider>
            </FormikProvider>

        </>
    );
};

export default AddAward;
